import { useEnergyTypeResolution } from 'src/composables/useEnergyTypeResolution'
import { decode as base64UrlDecode, encode as base64urlEncode } from 'universal-base64url'

import * as Sentry from '@sentry/vue'

export const changeRateRcMapping = {
  pocStreet: 'street',
  pocHouseNumber: 'houseNumber',
  pocZipCode: 'zipCode',
  pocCity: 'city',
  lastConsumptionValue: 'consumption',
  lastConsumptionValueNT: 'consumptionNT'
}

export const applyStateFromContract = (routeDataParam) => {
  let parsedData = null
  try {
    parsedData = JSON.parse(base64UrlDecode(routeDataParam))
  } catch (e) {
    console.warn(e)
    return null
  }

  const expectedKeys = [
    'caReference',
    'contractNumber',
    'contractDisplayName',
    'pocStreet',
    'pocHouseNumber',
    'pocZipCode',
    'pocCity',
    'customerNumber',
    'meterNumber',
    'lastConsumptionValue',
    'lastConsumptionValueNT',
    'multipleCounters',
    'energyType',
    'currentProductId',
    'tags',
    'fromVerification',
    'origin'
  ]

  const requiredKeys = [
    'caReference',
    'contractNumber',
    'pocStreet',
    'pocHouseNumber',
    'pocZipCode',
    'pocCity',
    'meterNumber'
  ]

  const changeRateDataInput = {}

  // Applying the input data like this ensures that only known keys are applied
  for (const key of expectedKeys) {
    const value = parsedData[key]
    if (requiredKeys.includes(key) && !value) {
      const e = new Error(`Missing required parameter "${key}"`)
      Sentry.captureException(e, scope => {
        scope.setExtras({
          dataParameter: routeDataParam,
          parsedData,
          requiredKeys
        })
      })
      return null
    }
    changeRateDataInput[key] = value
  }

  changeRateDataInput.origin = changeRateDataInput.origin ?? 'PORTAL'

  let tags = null
  if (changeRateDataInput.tags instanceof Array) {
    tags = changeRateDataInput.tags
  } else if (typeof changeRateDataInput.tags === 'string') {
    tags = changeRateDataInput.tags.split(',')
  }

  return {
    currentProductId: changeRateDataInput.currentProductId,
    queryDataProvider: changeRateDataInput,
    tag: tags
  }
}

export const useChangeRateData = () => {
  const { resolveCategory, promptSelection: promptEnergyTypeSelection } = useEnergyTypeResolution()

  const inferEnergyTypeFromExistingProduct = async (changeRateDataInput) => {
    const { energyType: resolvedEnergyType, category, manualSelectionRequired } = await resolveCategory({
      termProductId: changeRateDataInput.currentProductId,
      contractEnergyType: changeRateDataInput.energyType?.toLowerCase()
    })

    const contractDisplayName = changeRateDataInput.contractDisplayName
    let energyType = resolvedEnergyType

    if (manualSelectionRequired) {
      energyType = await promptEnergyTypeSelection(['electricity', 'electric_heating'], contractDisplayName)
    }

    changeRateDataInput.energyType = energyType
    changeRateDataInput.category = category

    return { energyType, category, newParam: base64urlEncode(JSON.stringify(changeRateDataInput)) }
  }

  return { inferEnergyTypeFromExistingProduct }
}
